export function inject(url, type, opts={}) {
  let callback = opts.callback;
  let uniqueCallback = opts.uniqueCallback;
  let id = opts.id;
  let async = opts.async || false;
  let unique = opts.unique || false;
  let exist = id && document.getElementById(id);
  let node = opts.node;
  let data = opts.data;
  let append = opts.append || false;

  if (unique && exist) {
    if (uniqueCallback) {
      uniqueCallback();
    }

    return;
  }

  if (exist) {
    document.getElementById(id).remove();
  }

  switch (type) {
    case "js":
      let d = document, g=d.createElement('script');
      let s = node || d.getElementsByTagName('script')[0];
      if (append) {
        s = document.scripts[document.scripts.length - 1];
      }

      g.type='text/javascript';

      if (data) {
        for (let key of Object.keys(data)) {
          g.dataset[key] = data[key];
        }
      }

      g.src=url;

      if (id) {
        g.id = id;
      }

      if (typeof(callback) === 'function') {
        g.onload = callback;
      }

      if (async) {
        g.async=true;
        g.defer=true;
      }

      s.parentNode.insertBefore(g,s);
      break;
    case "css":
      let css=document.createElement('link'); css.rel = 'stylesheet'; css.href= url;

      if (id) {
        css.id = id;
      }

      document.head.appendChild(css);
      break;
    default:
      break;
  }
}